import client from "./client";

export const getPermsCatalog = async () => (await client.get("/permissions/catalog")).data;
export const addCustomPerm = async (body) => (await client.post("/permissions/catalog", body)).data;
export const deleteCustomPerm = (key) => client.delete(`/permissions/catalog/${encodeURIComponent(key)}`);

export const getUserPerms = async (userId) => (await client.get(`/permissions/users/${userId}`)).data;
export const setUserPerms = async (userId, permissions) =>
  (await client.put(`/permissions/users/${userId}`, { permissions })).data;

export const getMyPerms = async () => (await client.get("/permissions/me")).data;
export const listAudit = async (limit = 200) =>
  (await client.get("/permissions/audit", { params: { limit } })).data;
export const listUserAudit = async (userId) =>
  (await client.get(`/permissions/audit/${userId}`)).data;
